import http from './http.service';
import store from '../store';
import Vue from 'vue';
import utils from '@/util';
import router from '@/router';
import auth from '@/services/auth.services';

/* Este módulo concentra todas as funções da API REST e repassa como prototype para o Vue */

const _path = 'api/'; // caminho em que serão acessadas as funçoes CRUD

function getKey() {
  return localStorage.getItem('accessToken');
}

function getPath(dataObj) {
  return _path + dataObj;
}

function filterByObject(target, filterObj) {
  if (typeof filterObj === 'string') {
    return target.filter((v) => {
      return JSON.stringify(v).toLowerCase().indexOf(filterObj.toLowerCase()) >= 0;
    });
  }

  let filterKeys = Object.keys(filterObj);
  let textIndex = filterKeys.indexOf('text');
  let text;

  if (textIndex >= 0) {
    text = filterObj['text'];
    filterKeys.splice(textIndex, 1);
  }

  return target.filter((v) => {
    let allTrue = true;
    filterKeys.forEach((k) => {
      if (Array.isArray(filterObj[k])) {
        allTrue = allTrue && filterObj[k].indexOf(v[k]) >= 0;
      } else {
        allTrue = allTrue && v[k] === filterObj[k];
      }

      if (text) {
        allTrue = allTrue && JSON.stringify(v).toLowerCase().indexOf(text.toLowerCase()) >= 0;
      }
    });
    return allTrue;
  });
}

// Nova versão para função getBilhetes com fetch
function searchFetch(dataObj, params) {
  return http.requestFetch(getPath(dataObj), params);
}

function search(dataObj, params) {
  /* Antes de realizar o GET, olha nos lookups se aquele dado já foi carregado.
   Caso já tenha sido, ele pega diretamente do store/lookups ao invés de fazer uma requisição ao server. */

  const lookups = ''; //window.getApp.$store.state.company.lookups;

  if (lookups && lookups[dataObj]) {
    let lkpData = params ? filterByObject(lookups[dataObj], params) : lookups[dataObj];
    // console.log('From lookups', lkpData);

    return Promise.resolve(lkpData);
  }

  return http.request(getPath(dataObj), params, { showLoader: true });
}

function getById(dataObj, dataKey, params) {
  return http.request(`${getPath(dataObj)}/${dataKey}`, params, { showLoader: true });
}

function getData(dataObj, params, dataKey) {
  let path = getPath(dataObj);

  if (dataKey) {
    path += `/${dataKey}`;
  }

  return http.request(path, params, { showLoader: true });
}

function save(dataObj, data, dataKey) {
  let path = getPath(dataObj);

  if (dataKey) {
    path += `/${dataKey}`;
    return http.put(path, data, { showLoader: true });
  }
  if (Array.isArray(data) && data[0].id) {
    path += `/`;
    return http.put(path, data, { showLoader: true });
  }

  return http.post(path, data, { showLoader: true });
}

function destroy(dataObj, dataKey) {
  return http.destroy(`${getPath(dataObj)}/${dataKey}`, { showLoader: true });
}

function doDelete(dataObj, key, value) {
  return http.destroy(`${getPath(dataObj)}?${key}=${value}`, { showLoader: true });
}

function execute(dataObj, params, dataKey) {
  let path = getPath(dataObj);

  if (dataKey) {
    path += `/${dataKey}`;
    return http.put(path, params, { showLoader: true });
  }

  return http.post(path, params, { showLoader: true });
}

function post(path, params) {
  return http.post(path, params, { showLoader: true });
}

function update(path, data, dataKey) {
  let url = getPath(path);
  if (dataKey) {
    url += `/${dataKey}`;
    return http.put(url, data);
  }
  //updateIn
  return http.put(url, data);
}

function updateIn(path, data) {
  let url = getPath(path);
  return http.put(url, data);
}

function saveFormData(dataObj, params, headers, dataKey) {
  let path = getPath(dataObj);
  if (dataKey) {
    path += `/${dataKey}`;
    // return http.putFormData(path, params, { showLoader: true });
  }
  // if (Array.isArray(data) && data[0].id) {
  //   path += `/`;
  //   return http.putFormData(path, params, { showLoader: true, headers });
  // }
  return http.postFormData(path, params, { showLoader: true });
}

function logout() {
  utils.formWarn({
    msgTitle: 'Até logo!',
    msgContent: 'Sua sessão foi encerrada com sucesso'
  });
  setTimeout(() => {
    auth.logout();
    router.replace('/');
  }, 1000);
}

function serverSentEvents(path, onMessage = () => {}, queryParams = '') {
  return new Promise((resolve, reject) => {
    const accessToken = getKey();

    fetch(`${process.env.VUE_APP_API_URL}/api/sse/initialize`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        if ([401, 403].includes(response.status)) {
          logout();
          return;
        }
        return response.json();
      })
      .then((data) => {
        const sseToken = data['sseToken'];
        const url = `${process.env.VUE_APP_API_URL}/api/sse/${path}?sseToken=${sseToken}${queryParams}`;
        const eventSource = new EventSource(url);

        eventSource.onmessage = (event) => {
          onMessage(event.data, eventSource);
          resolve(event.data, eventSource);
        };

        eventSource.onerror = (err) => {
          console.log('SSE error: ', err);
          reject(err);
          eventSource.close();
        };

        //on close
        eventSource.onclose = () => {
          console.log('SSE closed');
        };

        return eventSource;
      })
      .catch((error) => {
        if ([401, 403].includes(error.status)) {
          logout();
          return;
        }
        console.error('Erro ao inicializar SSE:', error);
        reject(error);
      });
  });
}

const api = {
  serverHost: http.host,
  search,
  searchFetch,
  getById,
  doDelete,
  getData,
  save,
  destroy,
  execute,
  post,
  update,
  updateIn,
  saveFormData,
  serverSentEvents
};

Vue.prototype.$api = api;

export default api;
